/** Italian VAT number: 11 digits + check digit (same algorithm as backend). */
export function isValidPiva(piva) {
  const p = (piva || "").trim();
  if (!/^\d{11}$/.test(p) || p === "00000000000") return false;
  let total = 0;
  for (let i = 0; i < 10; i += 1) {
    let d = Number(p[i]);
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    total += d;
  }
  return (10 - (total % 10)) % 10 === Number(p[10]);
}

/** "mario DE rossi" -> "Mario De Rossi" (apostrophes and hyphens handled). */
export function capitalizeName(s) {
  return (s || "").replace(/\s+/g, " ").trim().split(" ").map((w) =>
    w.split("-").map((part) => part.split("'").map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()).join("'")).join("-"),
  ).join(" ");
}
